<nav class="navbar navbar-default">
    <div class="container-fluid">
      <div class="navbar-header">
        <a class="navbar-brand" href="#">
            <img src="assets/images/mu_logo.png" alt="logo" class="logo">
            <span class="seperator">|</span>
            <img src="assets/images/elogo.png" alt="logo" class="elogo">
        </a>
      </div>
      <ul class="nav navbar-nav navbar-right">
        <!-- <li><a href="http://univ.secur.co.in/University/login" class="click-btn">CLICK HERE TO CONTINUE</a></li> -->
        <li class="right-nav"><a routerLink="/verification">Home</a></li>
        <li class="right-nav"><a routerLink="/faq">FAQ</a></li>
      </ul>
    </div>
</nav>

<div class="faq-section">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <h1 class="faq-hd">Refund Policy</h1>
                <p class="answer">Any payment received on this website is processed automatically and transferred to the University. These fees are non-refundable, once an e-verification request is submitted online. Hence, we request the user to double check that all necessary information and documents are correctly and completely updated at the time of submission. Only in exceptional cases, where a student has applied for her/his own record verification, and where the student is not able to provide any documents required by the University officials, SecUR may consider a refund request, based on the same being approved by the said University officials. In such circumstances, a refund shall be processed within 10-15 working days of the request being received from the student.</p>
            </div>
        </div>
    </div>
</div>

<div class="contact-section">
    <div class="contact-form">
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <h3 class="contact-form-hd">Fill the form & we will get back.</h3>
            <form>
              <input type="text" class="form-control form-input" placeholder="Enter your Email id">
              <textarea class="form-control form-input" placeholder="Enter your Query"></textarea>
              <button class="form-btn">Submit</button>
            </form>
          </div>
          <div class="col-md-8"></div>
        </div>
      </div>
    </div>
    <div class="footer">
        <div class="d-flex-footer">
            <a href="#"><img src="assets/images/footericon1.jpg" alt="icon" class="footer-icon"></a>
            <a href="#"><img src="assets/images/footericon2.jpg" alt="icon" class="footer-icon"></a>
            <a href="#"><img src="assets/images/footericon3.jpg" alt="icon" class="footer-icon"></a>
        </div>
        <div class="d-flex-footer">
            <a href="#" class="footer-link">Home</a>
            <a href="#" class="footer-link">Process</a>
            <a href="#" class="footer-link">Terms</a>
            <a href="#" class="footer-link">Privacy Policy</a>
            <a href="#" class="footer-link">Sitemap</a>
        </div>
    </div>
</div>